// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  E.g. 
  @include mix.position-fix(-15px, 0 0 -15px 0);
  @include mix.respond(1280px) { @include mix.position-reset(); }
*/
.mat-elevation-z0, .mat-mdc-elevation-specific.mat-elevation-z0 {
  box-shadow: var(--mat-app-elevation-shadow-level-0, 0px 0px 0px 0px --mat-sys-shadow, 0px 0px 0px 0px --mat-sys-shadow, 0px 0px 0px 0px --mat-sys-shadow);
}

.mat-elevation-z1, .mat-mdc-elevation-specific.mat-elevation-z1 {
  box-shadow: var(--mat-app-elevation-shadow-level-1, 0px 2px 1px -1px --mat-sys-shadow, 0px 1px 1px 0px --mat-sys-shadow, 0px 1px 3px 0px --mat-sys-shadow);
}

.mat-elevation-z2, .mat-mdc-elevation-specific.mat-elevation-z2 {
  box-shadow: var(--mat-app-elevation-shadow-level-2, 0px 3px 1px -2px --mat-sys-shadow, 0px 2px 2px 0px --mat-sys-shadow, 0px 1px 5px 0px --mat-sys-shadow);
}

.mat-elevation-z3, .mat-mdc-elevation-specific.mat-elevation-z3 {
  box-shadow: var(--mat-app-elevation-shadow-level-3, 0px 3px 3px -2px --mat-sys-shadow, 0px 3px 4px 0px --mat-sys-shadow, 0px 1px 8px 0px --mat-sys-shadow);
}

.mat-elevation-z4, .mat-mdc-elevation-specific.mat-elevation-z4 {
  box-shadow: var(--mat-app-elevation-shadow-level-4, 0px 2px 4px -1px --mat-sys-shadow, 0px 4px 5px 0px --mat-sys-shadow, 0px 1px 10px 0px --mat-sys-shadow);
}

.mat-elevation-z5, .mat-mdc-elevation-specific.mat-elevation-z5 {
  box-shadow: var(--mat-app-elevation-shadow-level-5, 0px 3px 5px -1px --mat-sys-shadow, 0px 5px 8px 0px --mat-sys-shadow, 0px 1px 14px 0px --mat-sys-shadow);
}

.mat-elevation-z6, .mat-mdc-elevation-specific.mat-elevation-z6 {
  box-shadow: var(--mat-app-elevation-shadow-level-6, 0px 3px 5px -1px --mat-sys-shadow, 0px 6px 10px 0px --mat-sys-shadow, 0px 1px 18px 0px --mat-sys-shadow);
}

.mat-elevation-z7, .mat-mdc-elevation-specific.mat-elevation-z7 {
  box-shadow: var(--mat-app-elevation-shadow-level-7, 0px 4px 5px -2px --mat-sys-shadow, 0px 7px 10px 1px --mat-sys-shadow, 0px 2px 16px 1px --mat-sys-shadow);
}

.mat-elevation-z8, .mat-mdc-elevation-specific.mat-elevation-z8 {
  box-shadow: var(--mat-app-elevation-shadow-level-8, 0px 5px 5px -3px --mat-sys-shadow, 0px 8px 10px 1px --mat-sys-shadow, 0px 3px 14px 2px --mat-sys-shadow);
}

.mat-elevation-z9, .mat-mdc-elevation-specific.mat-elevation-z9 {
  box-shadow: var(--mat-app-elevation-shadow-level-9, 0px 5px 6px -3px --mat-sys-shadow, 0px 9px 12px 1px --mat-sys-shadow, 0px 3px 16px 2px --mat-sys-shadow);
}

.mat-elevation-z10, .mat-mdc-elevation-specific.mat-elevation-z10 {
  box-shadow: var(--mat-app-elevation-shadow-level-10, 0px 6px 6px -3px --mat-sys-shadow, 0px 10px 14px 1px --mat-sys-shadow, 0px 4px 18px 3px --mat-sys-shadow);
}

.mat-elevation-z11, .mat-mdc-elevation-specific.mat-elevation-z11 {
  box-shadow: var(--mat-app-elevation-shadow-level-11, 0px 6px 7px -4px --mat-sys-shadow, 0px 11px 15px 1px --mat-sys-shadow, 0px 4px 20px 3px --mat-sys-shadow);
}

.mat-elevation-z12, .mat-mdc-elevation-specific.mat-elevation-z12 {
  box-shadow: var(--mat-app-elevation-shadow-level-12, 0px 7px 8px -4px --mat-sys-shadow, 0px 12px 17px 2px --mat-sys-shadow, 0px 5px 22px 4px --mat-sys-shadow);
}

.mat-elevation-z13, .mat-mdc-elevation-specific.mat-elevation-z13 {
  box-shadow: var(--mat-app-elevation-shadow-level-13, 0px 7px 8px -4px --mat-sys-shadow, 0px 13px 19px 2px --mat-sys-shadow, 0px 5px 24px 4px --mat-sys-shadow);
}

.mat-elevation-z14, .mat-mdc-elevation-specific.mat-elevation-z14 {
  box-shadow: var(--mat-app-elevation-shadow-level-14, 0px 7px 9px -4px --mat-sys-shadow, 0px 14px 21px 2px --mat-sys-shadow, 0px 5px 26px 4px --mat-sys-shadow);
}

.mat-elevation-z15, .mat-mdc-elevation-specific.mat-elevation-z15 {
  box-shadow: var(--mat-app-elevation-shadow-level-15, 0px 8px 9px -5px --mat-sys-shadow, 0px 15px 22px 2px --mat-sys-shadow, 0px 6px 28px 5px --mat-sys-shadow);
}

.mat-elevation-z16, .mat-mdc-elevation-specific.mat-elevation-z16 {
  box-shadow: var(--mat-app-elevation-shadow-level-16, 0px 8px 10px -5px --mat-sys-shadow, 0px 16px 24px 2px --mat-sys-shadow, 0px 6px 30px 5px --mat-sys-shadow);
}

.mat-elevation-z17, .mat-mdc-elevation-specific.mat-elevation-z17 {
  box-shadow: var(--mat-app-elevation-shadow-level-17, 0px 8px 11px -5px --mat-sys-shadow, 0px 17px 26px 2px --mat-sys-shadow, 0px 6px 32px 5px --mat-sys-shadow);
}

.mat-elevation-z18, .mat-mdc-elevation-specific.mat-elevation-z18 {
  box-shadow: var(--mat-app-elevation-shadow-level-18, 0px 9px 11px -5px --mat-sys-shadow, 0px 18px 28px 2px --mat-sys-shadow, 0px 7px 34px 6px --mat-sys-shadow);
}

.mat-elevation-z19, .mat-mdc-elevation-specific.mat-elevation-z19 {
  box-shadow: var(--mat-app-elevation-shadow-level-19, 0px 9px 12px -6px --mat-sys-shadow, 0px 19px 29px 2px --mat-sys-shadow, 0px 7px 36px 6px --mat-sys-shadow);
}

.mat-elevation-z20, .mat-mdc-elevation-specific.mat-elevation-z20 {
  box-shadow: var(--mat-app-elevation-shadow-level-20, 0px 10px 13px -6px --mat-sys-shadow, 0px 20px 31px 3px --mat-sys-shadow, 0px 8px 38px 7px --mat-sys-shadow);
}

.mat-elevation-z21, .mat-mdc-elevation-specific.mat-elevation-z21 {
  box-shadow: var(--mat-app-elevation-shadow-level-21, 0px 10px 13px -6px --mat-sys-shadow, 0px 21px 33px 3px --mat-sys-shadow, 0px 8px 40px 7px --mat-sys-shadow);
}

.mat-elevation-z22, .mat-mdc-elevation-specific.mat-elevation-z22 {
  box-shadow: var(--mat-app-elevation-shadow-level-22, 0px 10px 14px -6px --mat-sys-shadow, 0px 22px 35px 3px --mat-sys-shadow, 0px 8px 42px 7px --mat-sys-shadow);
}

.mat-elevation-z23, .mat-mdc-elevation-specific.mat-elevation-z23 {
  box-shadow: var(--mat-app-elevation-shadow-level-23, 0px 11px 14px -7px --mat-sys-shadow, 0px 23px 36px 3px --mat-sys-shadow, 0px 9px 44px 8px --mat-sys-shadow);
}

.mat-elevation-z24, .mat-mdc-elevation-specific.mat-elevation-z24 {
  box-shadow: var(--mat-app-elevation-shadow-level-24, 0px 11px 15px -7px --mat-sys-shadow, 0px 24px 38px 3px --mat-sys-shadow, 0px 9px 46px 8px --mat-sys-shadow);
}

html {
  --mat-sys-on-surface: initial;
}

.mat-app-background {
  background-color: var(--mat-app-background-color, var(--mat-sys-background, transparent));
  color: var(--mat-app-text-color, var(--mat-sys-on-background, inherit));
}

.backdrop {
  display: flex;
  height: 100vh;
}

.pic {
  background-color: #fafafa;
  background-image: url("/assets/img/CO-ResolvED-mark-only.svg");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 580px auto;
  display: block;
  width: 70%;
}
@media only screen and (max-width: 1200px) {
  .pic {
    width: 60%;
  }
}
@media only screen and (max-width: 950px) {
  .pic {
    background-size: 380px auto;
  }
}
@media only screen and (max-width: 768px) {
  .pic {
    display: none;
  }
}

.form {
  align-items: center;
  box-shadow: -4px 0 16px -6px rgba(47, 49, 100, 0.1);
  display: flex;
  flex: 1;
  justify-content: center;
  margin-left: 0;
  padding: 0 45px;
  position: static;
  width: 25vw;
}
@media only screen and (max-width: 1200px) {
  .form {
    padding: 0 25px;
  }
}
@media only screen and (max-width: 768px) {
  .form {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: 0;
    transform: translate(-50%, -50%);
  }
}

.thank-you-form-content {
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 24px;
}

.centered-fields {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.create-account-field.narrow,
.buttons.narrow {
  width: 240px !important;
  min-width: 0;
  margin-left: 0;
  margin-right: 0;
}

.create-account-form {
  width: 100%;
}

.thank-you-header {
  text-align: left;
  margin-bottom: 12px;
}
.thank-you-header h2 {
  margin-bottom: 10px;
  font-size: 1.6rem;
  font-weight: 600;
}
.thank-you-header .subtitle {
  font-size: 1rem;
  color: #555;
}
.thank-you-header .subtitle a {
  color: #1976d2;
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/styles/abstracts/_mixins.scss","webpack://./node_modules/@angular/material/core/_core.scss","webpack://./src/app/shared/components/dispute-resolution/thank-you-verify-email/thank-you-verify-email.component.scss"],"names":[],"mappings":"AAyBE;;;;CAAA;ACmBI;EACE,yJAAA;ACtCR;;ADqCM;EACE,0JAAA;AClCR;;ADiCM;EACE,0JAAA;AC9BR;;AD6BM;EACE,0JAAA;AC1BR;;ADyBM;EACE,2JAAA;ACtBR;;ADqBM;EACE,2JAAA;AClBR;;ADiBM;EACE,4JAAA;ACdR;;ADaM;EACE,4JAAA;ACVR;;ADSM;EACE,4JAAA;ACNR;;ADKM;EACE,4JAAA;ACFR;;ADCM;EACE,8JAAA;ACER;;ADHM;EACE,8JAAA;ACMR;;ADPM;EACE,8JAAA;ACUR;;ADXM;EACE,8JAAA;ACcR;;ADfM;EACE,8JAAA;ACkBR;;ADnBM;EACE,8JAAA;ACsBR;;ADvBM;EACE,+JAAA;AC0BR;;AD3BM;EACE,+JAAA;AC8BR;;AD/BM;EACE,+JAAA;ACkCR;;ADnCM;EACE,+JAAA;ACsCR;;ADvCM;EACE,gKAAA;AC0CR;;AD3CM;EACE,gKAAA;AC8CR;;AD/CM;EACE,gKAAA;ACkDR;;ADnDM;EACE,gKAAA;ACsDR;;ADvDM;EACE,gKAAA;AC0DR;;ADvFE;EACE,6BAAA;AC0FJ;;ADnFI;EACE,yFAAA;EACA,uEAAA;ACsFN;;AA3GA;EACE,aAAA;EACA,aAAA;AA8GF;;AA3GA;EACE,yBAAA;EACA,8DAAA;EACA,kCAAA;EACA,4BAAA;EACA,2BAAA;EACA,cAAA;EACA,UAAA;AA8GF;AF5GI;EETJ;IAUI,UAAA;EA+GF;AACF;AFjHI;EETJ;IAcI,2BAAA;EAgHF;AACF;AFtHI;EETJ;IAkBI,aAAA;EAiHF;AACF;;AA9GA;EACE,mBAAA;EACA,mDAAA;EACA,aAAA;EACA,OAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAiHF;AFvII;EEaJ;IAYI,eAAA;EAkHF;AACF;AF5II;EEaJ;IAgBI,kBAAA;IACA,QAAA;IACA,SAAA;IACA,cAAA;IACA,gCAAA;EAmHF;AACF;;AAhHA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,SAAA;AAmHF;;AAhHA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AAmHF;;AAhHA;;EAEE,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AAmHF;;AAhHA;EACE,WAAA;AAmHF;;AAhHA;EACE,gBAAA;EACA,mBAAA;AAmHF;AAlHE;EACE,mBAAA;EACA,iBAAA;EACA,gBAAA;AAoHJ;AAlHE;EACE,eAAA;EACA,WAAA;AAoHJ;AAnHI;EACE,cAAA;EACA,0BAAA;AAqHN","sourcesContent":["// BEM Mixins\r\n@mixin e($element) {\r\n    &__#{$element} {\r\n      @content;\r\n    }\r\n  }\r\n  @mixin m($modifier) {\r\n    &--#{$modifier} {\r\n      @content;\r\n    }\r\n  }\r\n  @mixin c($child) {\r\n    &-#{$child} {\r\n      @content;\r\n    }\r\n  }\r\n  \r\n  // Media Query Mixin\r\n  @mixin respond($respond) {\r\n    @media only screen and (max-width: #{$respond}) {\r\n      @content;\r\n    }\r\n  }\r\n  \r\n  // Position fixing (generally used for forms)\r\n  /*\r\n    E.g. \r\n    @include mix.position-fix(-15px, 0 0 -15px 0);\r\n    @include mix.respond(1280px) { @include mix.position-reset(); }\r\n  */\r\n  @mixin position-fix($top, $margin: 0 0 0 0) {\r\n    margin: $margin;\r\n    position: relative;\r\n    top: $top;\r\n  }\r\n  \r\n  @mixin position-reset() {\r\n    margin: 0;\r\n    position: static;\r\n    top: 0;\r\n  }","@use './m3-app';\n@use './tokens/token-utils';\n@use './style/elevation';\n\n$fallbacks: m3-app.get-tokens();\n\n/// @deprecated This mixin is a no-op and is going to be removed in v21.\n@mixin core() {}\n\n// Emits the mat-app-background CSS class. This predefined class sets the\n// background color and text color of an element.\n@mixin app-background() {\n  // TODO: Move ripple styles to be dynamically loaded instead of in core.\n  // This variable is used as a fallback for the ripple element's\n  // background color. However, if it isn't defined anywhere, then MSS\n  // complains in its verification stage.\n  html {\n    --mat-sys-on-surface: initial;\n  }\n\n  // Wrapper element that provides the theme background when the\n  // user's content isn't inside of a `mat-sidenav-container`.\n  @at-root {\n    // Note: we need to emit fallback values here to avoid errors in internal builds.\n    .mat-app-background {\n      background-color: token-utils.slot(app-background-color, $fallbacks, transparent);\n      color: token-utils.slot(app-text-color, $fallbacks, inherit);\n    }\n  }\n}\n\n// Emits CSS classes for applying elevation. These classes follow the pattern\n// mat-elevation-z#, where # is the elevation number you want, from 0 to 24.\n// These predefined classes use the CSS box-shadow settings defined by the\n// Material Design specification.\n@mixin elevation-classes() {\n  @at-root {\n    // Provides external CSS classes for each elevation value. Each CSS class is formatted as\n    // `mat-elevation-z$z-value` where `$z-value` corresponds to the z-space to which the element\n    // is elevated.\n    @for $z-value from 0 through 24 {\n      $selector: elevation.$prefix + $z-value;\n      // We need the `mat-mdc-elevation-specific`, because some MDC mixins\n      // come with elevation baked in and we don't have a way of removing it.\n      .#{$selector}, .mat-mdc-elevation-specific.#{$selector} {\n        box-shadow: token-utils.slot('app-elevation-shadow-level-#{$z-value}', $fallbacks, none);\n      }\n    }\n  }\n}\n","@use 'sass:map';\r\n@use '../../../../../../src/styles/abstracts/mixins' as mix;\r\n@use '../../../../../../src/styles/abstracts/variables' as var;\r\n@use '../../../../../../src/styles/theme/theme-variables' as theme;\r\n\r\n.backdrop {\r\n  display: flex;\r\n  height: 100vh;\r\n}\r\n\r\n.pic {\r\n  background-color: #fafafa;\r\n  background-image: url(\"/assets/img/CO-ResolvED-mark-only.svg\");\r\n  background-position: center center;\r\n  background-repeat: no-repeat;\r\n  background-size: 580px auto;\r\n  display: block;\r\n  width: 70%;\r\n\r\n  @include mix.respond(1200px) {\r\n    width: 60%;\r\n  }\r\n\r\n  @include mix.respond(950px) {\r\n    background-size: 380px auto;\r\n  }\r\n\r\n  @include mix.respond(768px) {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.form {\r\n  align-items: center;\r\n  box-shadow: -4px 0 16px -6px rgba(map.get(theme.$ascend-primary, 500), 0.1);\r\n  display: flex;\r\n  flex: 1;\r\n  justify-content: center;\r\n  margin-left: 0;\r\n  padding: 0 45px;\r\n  position: static;\r\n  width: 25vw;\r\n\r\n  @include mix.respond(1200px) {\r\n    padding: 0 25px;\r\n  }\r\n\r\n  @include mix.respond(768px) {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    margin-left: 0;\r\n    transform: translate(-50%, -50%);\r\n  }\r\n}\r\n\r\n.thank-you-form-content {\r\n  width: 100%;\r\n  max-width: 400px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: stretch;\r\n  gap: 24px;\r\n}\r\n\r\n.centered-fields {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  width: 100%;\r\n}\r\n\r\n.create-account-field.narrow,\r\n.buttons.narrow {\r\n  width: 240px !important;\r\n  min-width: 0;\r\n  margin-left: 0;\r\n  margin-right: 0;\r\n}\r\n\r\n.create-account-form {\r\n  width: 100%;\r\n}\r\n\r\n.thank-you-header {\r\n  text-align: left;\r\n  margin-bottom: 12px;\r\n  h2 {\r\n    margin-bottom: 10px;\r\n    font-size: 1.6rem;\r\n    font-weight: 600;\r\n  }\r\n  .subtitle {\r\n    font-size: 1rem;\r\n    color: #555;\r\n    a {\r\n      color: #1976d2;\r\n      text-decoration: underline;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
